import stream from 'stream';

export default stream.Readable;
